import React, { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { useNavigate } from "react-router";
import { SlProgressBar } from "@shoelace-style/shoelace/dist/react";
import { CreativeContext } from "./CreativeCreation";
import useSpecial from "./WebView/utils/useSpecial";
import { buildProductPayload } from "./WebView/utils/ProductForm";

function WebViewAd({
  companyName,
  company,
  handleshow,
  // advId,
  creative_name,
  creative_type,
  subtype,
  editdata,
  flag,
  handlesubmit,
  createdEdited,
}) {
  const navigate = useNavigate();
  const { preview, setPreview } = useContext(CreativeContext);
  const [progress, setProgress] = useState(0);
  const [image, setImage] = useState()
  const [imageUrl, setImageUrl] = useState("")

  const [creativeurl, setcreativeurl] = useState("");
  const [gettingWebviewUrl, setGettingWebviewUrl] = useState(false);

  // Android/iOS JSON config files. The two uploaded URLs are stored server-side
  // in the creative's video_controls column ({ android_json, ios_json }). Optional.
  const [androidJsonUrl, setAndroidJsonUrl] = useState("");
  const [iosJsonUrl, setIosJsonUrl] = useState("");
  const [androidJsonProgress, setAndroidJsonProgress] = useState(0);
  const [iosJsonProgress, setIosJsonProgress] = useState(0);

  // "Get Webview URL" mode — three states:
  // null (default): no mode picked, no Get Webview URL helper at all — just
  //   the original plain manual flow (Creative URL, Upload Image, JSON configs).
  // "full_image": boost-listing webview (whole image is the click target).
  // "promoted": headline + description article layout, where the headline
  //   and/or a highlighted phrase in the description are the click targets.
  // Picking either mode hides the JSON config inputs and reveals Destination
  // URL + the Get Webview URL button; only affects the helper's generated
  // HTML — the rest of the creative (creativeurl, submit payload) is unchanged.
  const [webviewMode, setWebviewMode] = useState(null);
  // Promoted mode reuses the SAME upload field/state as full_image (image,
  // imageUrl, progress below) instead of a second upload — only the accepted
  // file types, validation and upload endpoint differ by mode. promotedMediaType
  // just remembers which endpoint/payload key (imageUrl vs videoUrl) to use.
  const [promotedMediaType, setPromotedMediaType] = useState("image");
  const [headline, setHeadline] = useState("");
  const [titleClickable, setTitleClickable] = useState(true);
  const [description, setDescription] = useState("");
  const [descLinkRange, setDescLinkRange] = useState(null); // { start, end } | null
  const [promotedShare, setPromotedShare] = useState(false);

  const IMAGE_TYPES = ["image/jpg", "image/jpeg", "image/webp", "image/png"];

  // Captures the current text selection in the description textarea as the
  // clickable link span (offsets, not a rich-text editor) — mirrors the
  // reference sample's single highlighted phrase inside the description.
  const descriptionRef = useRef(null);
  const handleMakeDescLink = () => {
    const textarea = descriptionRef.current;
    if (!textarea) return;
    const { selectionStart, selectionEnd } = textarea;
    if (selectionEnd > selectionStart) {
      setDescLinkRange({ start: selectionStart, end: selectionEnd });
    } else {
      Toast("error", "Select a word or phrase in the description first");
    }
  };

  const jsonUpload = async (e, which) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const setProg = which === "android" ? setAndroidJsonProgress : setIosJsonProgress;
    const setVal = which === "android" ? setAndroidJsonUrl : setIosJsonUrl;
    try {
      const formData = new FormData();
      formData.append("files", file);
      const res = await api({
        url: `/upload/brandLottie`,
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (data) =>
          setProg(Math.round((100 * data.loaded) / data.total)),
      });
      if (res.code === 200) {
        setVal(res.data.data);
      } else {
        setProg(0);
        Toast("error", res.data?.message || "Upload failed");
      }
    } catch (error) {
      setProg(0);
      Toast("error", "Upload failed");
    }
  };
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });

  let watchcreativeurl = watch("creativeurl", "");
  const destinationUrl = watch("destination_url", "");

  // "Get Webview URL" builds the boost-listing webview from the destination URL
  // + the uploaded image, and drops the hosted URL into Creative URL — which is
  // what gets saved as the creative's url.
  const uploadedImage = imageUrl || editdata?.img_urls || "";
  const promotedHasClickTarget = titleClickable || Boolean(descLinkRange);
  const canGetWebviewUrl =
    webviewMode === "promoted"
      ? Boolean(creative_name) &&
        Boolean(headline.trim()) &&
        Boolean(description.trim()) &&
        Boolean(imageUrl) &&
        (!promotedHasClickTarget || Boolean(destinationUrl?.trim()))
      : Boolean(destinationUrl?.trim()) && Boolean(uploadedImage) && Boolean(creative_name);

  const handleGetWebviewUrl = async () => {
    setGettingWebviewUrl(true);
    try {
      const data =
        webviewMode === "promoted"
          ? {
              mode: "promoted",
              creative_name,
              headline: headline.trim(),
              titleClickable,
              description,
              linkStart: descLinkRange?.start ?? null,
              linkEnd: descLinkRange?.end ?? null,
              destination_url: destinationUrl?.trim() || "",
              share: promotedShare,
              ...(promotedMediaType === "video"
                ? { videoUrl: imageUrl }
                : { imageUrl: imageUrl }),
            }
          : {
              creative_name,
              destination_url: destinationUrl.trim(),
              imageUrl: uploadedImage,
            };
      const res = await api({
        url: `/creatives/web/getWebviewUrl`,
        method: "POST",
        responseType: "json",
        data,
      });
      if (res?.code === 200 && res?.data?.webview_url) {
        setValue("creativeurl", res.data.webview_url, { shouldValidate: true });
        Toast("success", "Webview URL generated");
      } else {
        Toast("error", res?.data?.message || res?.message || "Could not get webview URL");
      }
    } catch (error) {
      console.error(error);
      Toast("error", error?.response?.data?.message || "Could not get webview URL");
    } finally {
      setGettingWebviewUrl(false);
    }
  };
const { SpecialForm, schema } = useSpecial({ 
    control, 
    register, 
    editdata: editdata || null,
    setValue,
    errors 
  });
  useEffect(() => {
    if (watchcreativeurl !== false) {
      setcreativeurl(watchcreativeurl);
      setPreview(prev => ({ ...prev, creativeurls: watchcreativeurl }));
    } else {
      setPreview(prev => ({ ...prev, creativeurls: "" }));
    }
  }, [watchcreativeurl]);

  useEffect(() => {
    if (flag === "edit") {
      setPreview(prev => ({
        ...prev,
        sub_type: editdata.sub_type,
        img_urls: editdata.video_urls,
      }));
      // Prefill Android/iOS JSON URLs from the stored video_controls (object or JSON string).
      let vc = editdata?.video_controls;
      if (typeof vc === "string") {
        try { vc = JSON.parse(vc); } catch (e) { vc = null; }
      }
      if (vc) {
        setAndroidJsonUrl(vc.android_json || "");
        setIosJsonUrl(vc.ios_json || "");
      }
    }
    setPreview(prev => ({ ...prev, sub_type: "webviewad" }));
  }, [company]);

  const onSubmit = async (data) => {
    if (flag === "add") {
      handlesubmit(true);
      let obj = {
        company_id: company,
        // adv_id: advId,
        company_name: companyName,
        creative_name,
        creative_type,
        sub_type: subtype,
        creativeurl: creativeurl,
        imageUrl,
        bl_version:data.version,
        schema,
        special:data.special,
        video_controls: {
          android_json: androidJsonUrl || "",
          ios_json: iosJsonUrl || "",
        },
        ...buildProductPayload(data),
      };
      // if (advId !== "" && creative_name !== "") {
      if (creative_name !== "") {
        try {
          let res = await api({
            url: `/creatives/web/webviewad`,
            method: "POST",
            responseType: "json",
            data: obj,
          });
          if (res?.code === 200) {
            Toast("success", " Creative Created Successfully  ");
            handleshow(false);
            createdEdited(true);
          } else {
            Toast("error", res.data.message);
          }
        } catch (error) {
          console.error(error);
          if (error.response.status === 401) navigate("/");
        }
      }
    } else if (flag === "edit") {
      let obj = {
        creative_name: creative_name,
        creative_type: editdata.creative_type,
        creative_id: editdata.creative_id,
        sub_type: editdata.sub_type,
        bl_version : data.version,
        schema,
        special:data.special,
        video_controls: {
          android_json: androidJsonUrl || "",
          ios_json: iosJsonUrl || "",
        },
        ...buildProductPayload(data),
      };
      creativeurl !== ""
        ? (obj.creativeurl = creativeurl)
        : (obj.creativeurl = editdata.video_urls);
        imageUrl !== ""
        ? (obj.imageUrl = imageUrl)
        : (obj.imageUrl = editdata.img_urls);
      try {
        let res = await api({
          url: `/creatives/web/editwebviewad`,
          method: "POST",
          responseType: "json",
          data: obj,
        });
        if (res?.code === 200) {
          Toast("success", " Creative Edited Successfully  ");
          handleshow(false);
          createdEdited(true);
        } else {
          Toast("error", res.data.message);
        }
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
  };

  // Full_image mode: image only, uploaded to /upload/webviewImage (unchanged).
  // Promoted mode: image OR mp4 video (max 25MB), uploaded to
  // /upload/webview/promotedimage (a webview-only copy of the legacy
  // /upload/promotedimage — separate endpoint so this flow's behavior can't
  // affect the legacy Promoted Image/Gallery/Video creative types) or
  // /upload/video (legacy, unchanged — not touched since it isn't buggy)
  // — same field, same imageUrl state, just a different endpoint and
  // validation depending on webviewMode.
  const handleImage = (e)=>{
    try {
      if (e.target.files && e.target.files.length > 0) {
        const file = e.target.files[0];
        if (webviewMode === "promoted") {
          if (IMAGE_TYPES.includes(file.type)) {
            setPromotedMediaType("image");
          } else if (file.type === "video/mp4") {
            if (file.size >= 26214400) {
              Toast("error", "Video size must be less than 25mb");
              setValue("creativeImg", "");
              return;
            }
            setPromotedMediaType("video");
          } else {
            Toast("error", "Only jpg, jpeg, webp, png images or mp4 video accepted");
            setValue("creativeImg", "");
            return;
          }
          setImage(file);
        } else if (
          file.type === "image/jpg" ||
          file.type === "image/jpeg" ||
          file.type === "image/webp" ||
          file.type === "image/png"
        ) {
          setPromotedMediaType("image");
          setImage(file);
        } else {
          Toast("error", "Only jpg, jpeg, webp, png formats accepted");
          setValue("image", "");
        }
      } else {
        if (flag === "edit") {
          setImageUrl(editdata.img_urls);
          setPreview({ ...preview, img_urls: editdata.img_urls });
        } else {
          setProgress(0);
          setImageUrl("");
          setPreview({ ...preview, img_urls: "" });
        }
      }
    } catch (error) {
      console.error(error)
    }
  }

  const formData1 = new FormData();
  formData1.append("files", image);
  const imageUpload = async () => {
    try {
      let url = await api({
        url:
          webviewMode === "promoted"
            ? promotedMediaType === "video"
              ? `/upload/video`
              : `/upload/webview/promotedimage`
            : `/upload/webviewImage`,
        method: "POST",
        responseType: "json",
        data: formData1,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (data) => {
          setProgress(Math.round((100 * data.loaded) / data.total));
        },
      });
      if (url.code === 200) {
        setImageUrl(url.data.data);
        // setPreview({ ...preview, img_urls: url.data.data });
      } else {
        setProgress(0);
        setValue("image", null);
        setImage("");
        Toast("error", url.data.message);
      }
    } catch (error) {
      Toast("error", error);
    }
  }

  useEffect(()=>{
    if(image)
    imageUpload()
  },[image])

  // Switching between the "promoted" upload (image-or-video) and the plain
  // image upload (default/full_image — same validation/endpoint either way)
  // invalidates whatever was already uploaded, so clear it rather than let a
  // stale, wrong-typed URL silently carry over. Toggling within the plain
  // image side (default <-> full_image) doesn't need a reset — same upload.
  const uploadClass = webviewMode === "promoted" ? "promoted" : "image";
  const isFirstUploadClassRender = useRef(true);
  useEffect(() => {
    if (isFirstUploadClassRender.current) {
      isFirstUploadClassRender.current = false;
      return;
    }
    setImage(null);
    setImageUrl("");
    setProgress(0);
    setPromotedMediaType("image");
    setValue("creativeImg", "");
  }, [uploadClass]);

  // Same field/handlers regardless of mode — only its label/accept and where
  // it renders (standalone vs inside the promoted block) change.
  const uploadField = (
    <div className="row mb-3">
      <div className="col">
        <label className="form-label">
          {webviewMode === "promoted" ? "Upload Media (image or mp4 video, max 25MB)" : "Upload Image"}
        </label>
        <input
          type="file"
          className="form-control"
          name="creativeImg"
          accept={webviewMode === "promoted" ? "image/jpeg,image/png,image/webp,video/mp4" : "image/jpeg,image/png,image/webp"}
          {...register("creativeImg", {
            required: editdata.img_urls === "" ? true : false,
            onChange: (e) => handleImage(e)
          })}
        />
        {editdata.img_urls === "" && errors.creativeImg && (
          <p className="text-red-600">{"Image is required!"}</p>
        )}
        <p>{imageUrl || editdata.img_urls}</p>
      </div>
    </div>
  );

  return (
    <>
      {/* The drawer this renders in (CreativeCreation.js) sizes itself to
          fit-content, and its "Upload" column is a Bootstrap col-6 (a fixed
          percentage of the drawer's own fit-content width, not shrink-to-fit)
          — a min-width on a descendant doesn't reliably propagate through
          that percentage column into the drawer's own sizing. An always-
          present spacer with an explicit width (not min-width) sidesteps
          that: explicit widths participate directly in fit-content's
          max-content calculation, so the drawer settles on a stable width
          regardless of which Get Webview URL Mode fields are currently shown. */}
      <div aria-hidden="true" style={{ width: "38rem", maxWidth: "100%", height: 0, overflow: "hidden" }} />
      <div className="row">
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <div className="row">
            <section className="col-12">
              {/* Get Webview URL mode: null (default) = original plain flow, no
                  helper. full_image keeps the whole-image click-target webview;
                  promoted builds a headline/description article layout with
                  the headline and/or a highlighted phrase in the description
                  as the click target instead. */}
              <div className="row mb-3">
                <div className="col">
                  <label className="form-label d-block">Get Webview URL Mode</label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="webviewModeFullImage"
                      name="webviewMode"
                      checked={webviewMode === "full_image"}
                      onClick={() => setWebviewMode(webviewMode === "full_image" ? null : "full_image")}
                      onChange={() => {}}
                    />
                    <label className="form-check-label" htmlFor="webviewModeFullImage">Full Image</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="webviewModePromoted"
                      name="webviewMode"
                      checked={webviewMode === "promoted"}
                      onClick={() => setWebviewMode(webviewMode === "promoted" ? null : "promoted")}
                      onChange={() => {}}
                    />
                    <label className="form-check-label" htmlFor="webviewModePromoted">Promoted</label>
                  </div>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col">
                  <label className="form-label">Enter Creative URL</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={editdata.video_urls}
                    name="creativeurl"
                    placeholder="Enter creative url"
                    {...register("creativeurl", {
                      required: "Please enter a URL.",
                      pattern: {
                        // Allow template tokens in query (e.g. &token={TOKEN}); path may include {} etc.
                        value: /^(?!.*\.(mp4|avi|mov|wmv|flv|mkv|webm|mp3|wav|ogg|jpg|jpeg|png|gif|bmp)(\?.*)?$)(https?:\/\/)?([\w.-]+)\.[a-z]{2,6}(\/[\w\-./?=&%{}]*)?$/i,
                        message: "Enter proper URL, Media URL's and Invalid URL's are not allowed",
                      },
                    })}
                  />
                  {errors.creativeurl && (
                    <p className="text-red-600">{errors.creativeurl.message}</p>
                  )}
                </div>
              </div>

              {webviewMode !== "promoted" && uploadField}

              {webviewMode === "promoted" && (
                <div className="border rounded p-3 mb-3">
                  {uploadField}
                  <div className="row mb-3">
                    <div className="col">
                      <label className="form-label">Headline</label>
                      <input
                        type="text"
                        className="form-control"
                        value={headline}
                        onChange={(e) => setHeadline(e.target.value)}
                        placeholder="Enter headline"
                      />
                      <div className="form-check mt-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="titleClickable"
                          checked={titleClickable}
                          onChange={(e) => setTitleClickable(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="titleClickable">
                          Title redirects to destination URL
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col">
                      <label className="form-label">Description</label>
                      <textarea
                        ref={descriptionRef}
                        className="form-control"
                        rows={4}
                        value={description}
                        onChange={(e) => {
                          setDescription(e.target.value);
                          setDescLinkRange(null);
                        }}
                        placeholder="Enter description"
                      />
                      <div className="d-flex align-items-center gap-2 mt-2">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          onClick={handleMakeDescLink}
                        >
                          Make Selected Text a Link
                        </button>
                        {descLinkRange && (
                          <span className="text-muted">
                            Linked: "{description.slice(descLinkRange.start, descLinkRange.end)}"
                            <button
                              type="button"
                              className="btn btn-sm btn-link text-danger"
                              onClick={() => setDescLinkRange(null)}
                            >
                              Clear
                            </button>
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="form-check mb-3">
                    <input
                      type="checkbox"
                      id="promotedShare"
                      checked={promotedShare}
                      onChange={(e) => setPromotedShare(e.target.checked)}
                      className="form-check-input"
                    />
                    <label htmlFor="promotedShare" className="form-check-label">Share</label>
                  </div>
                </div>
              )}

              {/* Android / iOS JSON config files (optional) — only shown in the
                  default (no mode picked) flow; full_image/promoted hide these
                  in favor of Destination URL + Get Webview URL below. Uploaded
                  to the brand-ads bucket; the two URLs are saved in video_controls. */}
              {!webviewMode && (
                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Android JSON (.json)</label>
                    <input
                      type="file"
                      className="form-control"
                      accept=".json,application/json"
                      onChange={(e) => jsonUpload(e, "android")}
                    />
                    {androidJsonProgress > 0 && androidJsonProgress < 100 ? (
                      <SlProgressBar value={androidJsonProgress}>
                        {androidJsonProgress}%
                      </SlProgressBar>
                    ) : androidJsonUrl ? (
                      <div className="d-flex align-items-center gap-2">
                        <span className="text-success">✓</span>
                        <span className="text-break">{androidJsonUrl}</span>
                      </div>
                    ) : null}
                  </div>
                  <div className="col">
                    <label className="form-label">iOS JSON (.json)</label>
                    <input
                      type="file"
                      className="form-control"
                      accept=".json,application/json"
                      onChange={(e) => jsonUpload(e, "ios")}
                    />
                    {iosJsonProgress > 0 && iosJsonProgress < 100 ? (
                      <SlProgressBar value={iosJsonProgress}>
                        {iosJsonProgress}%
                      </SlProgressBar>
                    ) : iosJsonUrl ? (
                      <div className="d-flex align-items-center gap-2">
                        <span className="text-success">✓</span>
                        <span className="text-break">{iosJsonUrl}</span>
                      </div>
                    ) : null}
                  </div>
                </div>
              )}

              {webviewMode && (
              <div className="row mb-3">
                <div className="col">
                  <label className="form-label">Enter Destination URL</label>
                  <input
                    type="text"
                    className="form-control"
                    name="destination_url"
                    placeholder="Enter the URL the webview should open"
                    {...register("destination_url", {
                      required: false,
                      pattern: {
                        value: /^(?!.*\.(mp4|avi|mov|wmv|flv|mkv|webm|mp3|wav|ogg|jpg|jpeg|png|gif|bmp)(\?.*)?$)(https?:\/\/)?([\w.-]+)\.[a-z]{2,6}(\/[\w\-./?=&%{}]*)?$/i,
                        message: "Enter proper URL, Media URL's and Invalid URL's are not allowed",
                      },
                    })}
                  />
                  {errors.destination_url && (
                    <p className="text-red-600">{errors.destination_url.message}</p>
                  )}
                </div>
              </div>
              )}

              {webviewMode && (
              <div className="row mb-3">
                <div className="col">
                  <button
                    type="button"
                    className="btn btn-outline-primary hover:cursor-pointer"
                    onClick={handleGetWebviewUrl}
                    disabled={!canGetWebviewUrl || gettingWebviewUrl}
                    title={
                      canGetWebviewUrl
                        ? "Build the webview and fill the Creative URL"
                        : webviewMode === "promoted"
                        ? "Enter creative name, headline, description and upload media first"
                        : "Enter the destination URL and upload an image first"
                    }
                  >
                    {gettingWebviewUrl && (
                      <span
                        className="spinner-grow spinner-grow-sm me-1"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                    {gettingWebviewUrl ? "Getting Webview URL..." : "Get Webview URL"}
                  </button>
                </div>
              </div>
              )}
              <div className="row mx-2">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" defaultChecked={editdata?.bl_version === 1 ? true  : false} value="" {...register("version", {
                    required:false
                  })} />
                  <label class="form-check-label" for="flexCheckDefault">
                   Below Verson 8.4.0
                  </label>
                </div>
              </div>
             {SpecialForm()}
              <div className="my-3 text-end">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={progress > 0 && progress < 100 ? true : false}
                >
                  Save Creative
                </button>
              </div>
            </section>
          </div>
         
        </form>
      </div>
    </>
  );
}

export default WebViewAd;
